/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `numeric` - Numeric
 * * `extra_data` - Extra Data
 * * `site_extra_data` - Site Extra Data
 * @export
 */
export const ConditionExpressionFieldTypeEnum = {
    Numeric: 'numeric',
    ExtraData: 'extra_data',
    SiteExtraData: 'site_extra_data'
} as const;
export type ConditionExpressionFieldTypeEnum = typeof ConditionExpressionFieldTypeEnum[keyof typeof ConditionExpressionFieldTypeEnum];


export function instanceOfConditionExpressionFieldTypeEnum(value: any): boolean {
    for (const key in ConditionExpressionFieldTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(ConditionExpressionFieldTypeEnum, key)) {
            if (ConditionExpressionFieldTypeEnum[key as keyof typeof ConditionExpressionFieldTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ConditionExpressionFieldTypeEnumFromJSON(json: any): ConditionExpressionFieldTypeEnum {
    return ConditionExpressionFieldTypeEnumFromJSONTyped(json, false);
}

export function ConditionExpressionFieldTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConditionExpressionFieldTypeEnum {
    return json as ConditionExpressionFieldTypeEnum;
}

export function ConditionExpressionFieldTypeEnumToJSON(value?: ConditionExpressionFieldTypeEnum | null): any {
    return value as any;
}

export function ConditionExpressionFieldTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): ConditionExpressionFieldTypeEnum {
    return value as ConditionExpressionFieldTypeEnum;
}

